/**
 * useNarrowViewport - true while the viewport is phone-sized, so the S3 and S4
 * worklists show one card per invoice instead of a table that cannot fit.
 *
 * The breakpoint is the width below which the six-column failed-list table
 * (about 725px wide at its natural size) no longer fits. It reads the browser's
 * media query and follows it as the window changes; it never schedules a read
 * of its own (PD-33) - the only subscription is the media-query change event.
 */

import { useSyncExternalStore } from 'react'

export const NARROW_VIEWPORT_QUERY = '(max-width: 767px)'

function subscribe(onChange: () => void): () => void {
  const query = window.matchMedia(NARROW_VIEWPORT_QUERY)
  query.addEventListener('change', onChange)
  return () => query.removeEventListener('change', onChange)
}

function snapshot(): boolean {
  return window.matchMedia(NARROW_VIEWPORT_QUERY).matches
}

export function useNarrowViewport(): boolean {
  return useSyncExternalStore(subscribe, snapshot)
}
